import React from "react"
import { list } from "../../data/Data"
import { Link } from "react-router-dom/cjs/react-router-dom.min"


const RecentCard = () => {
  return (
    <>
      <div  className='content grid3 mtop'>
        {list.map((val, index) => {
          const { cover, category, location, name, price, type,ptext } = val
          return (
            <div className='box shadow' key={index}>
              <div className='img'>
                <img src={cover} alt='' />
              </div>
              <div className='text'>

                <h4>{name}</h4>
                <p>
                  <i className='fa '></i> {ptext}
                </p>
                <p>
                  <i className='fa fa-location-dot'></i> {location}
                </p>
              </div>
              <div className='button flex p-3'>
                <div>
                 <Link to="/publications"> <button className='btn2 py-2  px-4'>{price}</button></Link> <label htmlFor=''></label>
                </div>
               
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default RecentCard
